import React from 'react'
import ProductSang from '../../Products/ProductSang'
import { Link } from 'react-router-dom'
import CategorySangPageORGEN from '../../Products/CategorySangPageORGEN'

function ProductCstegorySang() {
  return (
    <div className='c-Product' >
    <div className='c-titleProduct'>
        <div className='titleProduct'>
            <h1> Stone Category </h1>
            <p> The stone group includes all kinds of natural stones such as marble, granite and travertine, which are used in construction and interior decoration. These stones are used in flooring, facade and decorative surfaces due to their beauty and high durability. </p>
        </div>
    </div>
    
    <div className='c-AllProduct'>
        <div className='AllProduct-Sang'>
            {CategorySangPageORGEN.map((item) => {
                return (
                    <Link to={`product?name=stone&id=${item.CategoryID}`}  key={item.ID}  onClick={() => window.scrollTo(0, 0)}>
                        <div className="p-Product" key={item.ID}>
                            <div className='c-img'> <img  src={item.ImageURL} alt="محصول 1" /> </div>
                            <h4> {item.Name} </h4>
                        </div>
                    </Link>
                )
            })}
        </div>
    </div>
</div>
  )
}

export default ProductCstegorySang
